import { t } from "@lingui/macro";
import {
  NavigationProp,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { useCallback } from "react";

import {
  Pressable,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { LessonsStackNavigatorParamList } from "../../../../../../../../navigators/LessonsStackNavigator/types";

type Props = {
  id: string;
  date: string;
  endDate?: string;
  slotsCount?: number;
  instructorId: string;
  lessonTypeId?: string;
  durationMins?: number;
};

export const AvailableDatesCard = ({
  id,
  date,
  endDate,
  slotsCount,
  instructorId,
  lessonTypeId,
  durationMins,
}: Props) => {
  const route =
    useRoute<RouteProp<LessonsStackNavigatorParamList, "LessonsHome">>();
  const facilitySlug = route?.params?.facilitySlug;
  const navigation =
    useNavigation<NavigationProp<LessonsStackNavigatorParamList>>();

  const onPress = useCallback(() => {
    if (date === "full-availability") {
      navigation.navigate("InstructorDetail", {
        facilitySlug,
        instructorId,
        duration: durationMins ? durationMins.toString() : undefined,
        lessonTypeId,
      });
    } else {
      if (slotsCount) {
        navigation.navigate("InstructorDetail", {
          facilitySlug,
          instructorId,
          date: id,
          duration: durationMins ? durationMins.toString() : undefined,
          lessonTypeId,
        });
      }
    }
  }, [
    date,
    durationMins,
    facilitySlug,
    id,
    instructorId,
    lessonTypeId,
    navigation,
    slotsCount,
  ]);

  return (
    <Pressable
      onPress={onPress}
      key={date}
      height={60}
      minWidth={152}
      flexBasis={{ base: "auto", lg: "24%" }}
    >
      {date !== "full-availability" ? (
        <VStack
          borderRadius="2"
          flexBasis={{ base: "auto", lg: "24%" }}
          flex={1}
          gap={1}
          justifyContent="center"
          alignItems="flex-start"
          px={4}
          backgroundColor={
            slotsCount ? "surface-main-primary-subtlest" : "surface-secondary"
          }
        >
          {!endDate ? (
            <Text variant="mainBaseSemiBold">{date}</Text>
          ) : (
            <Text variant="mainBaseSemiBold">{`${date} - ${endDate}`}</Text>
          )}
          {slotsCount ? (
            <Text
              variant="mainSmallMedium"
              color="text-secondary"
            >{`${slotsCount} ${t`Times`}`}</Text>
          ) : (
            <Text
              variant="mainSmallMedium"
              color="text-secondary"
            >{t`No Availability`}</Text>
          )}
        </VStack>
      ) : (
        <VStack
          flex={1}
          px={3}
          alignItems="center"
          justifyContent="center"
          borderColor="surface-dividers"
          borderWidth={1.5}
          borderRadius="2"
        >
          <Text
            variant="mainBaseSemiBold"
            testID="view-full-availability-button"
          >{t`View Full Availability`}</Text>
        </VStack>
      )}
    </Pressable>
  );
};
